import React, {useState} from 'react'

import classnames from "classnames";

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";

import Box from "@mui/material/Box";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import {useDealContext} from "../../contexts/DealContext";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import Popover from "@mui/material/Popover";
import CircularProgress from '@mui/joy/CircularProgress';
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Tooltip from "@mui/material/Tooltip";
import {useUserContext} from "../../contexts/UserContext";
import SendIcon from "@mui/icons-material/Send";
import {getQuotesDataAndPDFs} from "../Email/fetchData/getQuotesDataAndPDFs";
import {EmailModal} from "../Email/EmailModal";
import {DealCRMModal} from "./DealCRMPage/DealCRMModal";
import {PDFModal} from "./PDFModal";
import {DeskingModal} from "../PricingListPage/DeskingModal";
import {DealModal} from "../PricingListPage/DealModal";
import {useModalsStore} from "../../stores/modalsStore";
import {PDFDownloadLink} from "@react-pdf/renderer";
import {DealerDisclosurePDF} from "./DisclosurePDFs/Dealer/Lease/DealerDisclosurePDF";
import {PurchaseCustomerDisclosurePDF} from "./DisclosurePDFs/Customer/Purchase/PurchaseCustomerDisclosurePDF";
import {PurchaseDealerDisclosurePDF} from "./DisclosurePDFs/Dealer/Purchase/PurchaseDealerDisclosurePDF";
import {CustomerDisclosurePDF} from "./DisclosurePDFs/Customer/Lease/CustomerDisclosurePDF";
import {useFetchHook} from "../../hooks/useFetchHook";
import fetcher from "../../fetcher";
import {buildMiniQuoteSummaryString, copyQuoteHTMLTooltip} from "../../utils/CopyQuoteTooltip";
import FileCopyIcon from '@mui/icons-material/FileCopy';


let usePDF = () => [{url: '', loading: false}, function(){}]

if (process.env.NODE_ENV !== 'test') {
    import("@react-pdf/renderer")
        .then((mod) => {
            usePDF = mod.usePDF
        });
}

const DealHeader = ( { isModal } ) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { profileState, isFeatureFlagEnabled } = useUserContext()
    const openModal = useModalsStore((state) => state.openModal)
    const [deleteDealResponse, deleteDeal] = useFetchHook(fetcher.deleteDeal)

    const [isCopied, setIsCopied] = useState(false)

    const {
        dealState,
        dealColorLight,
        cloneDeal,
        setDealStateWithoutUpdate,
        setDealStateWithoutQuoteUpdate,
        setDealStateWithUpdate
    } = useDealContext()
    const [isCreatingDeal, setIsCreatingDeal] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);

    const isPurchase = dealState.is_purchase
    const companyName = profileState?.account_name

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const deskClonedDeal = (isPurchase) => {
        openModal({
            element: DeskingModal,
            id: "DeskingModal",
            props: {
                onSave: (data) =>  {
                    if (isTabletOrMobile) {
                        window.open(`/quotes/${data.id}`, "_self")
                    } else {
                        openModal({
                            element: DealModal,
                            id: "DealModal",
                            props: {
                                id: data.id,
                                deal_id: data.id,
                            }
                        })
                    }
                },
                ...dealState,
                is_purchase: isPurchase,
                is_one_pay: false,
                id: null
            }
        })
    }

    const deskCashPurchase = () => {
        openModal({
            element: DeskingModal,
            id: "DeskingModal",
            props: {
                onSave: (data) =>  {
                    if (isTabletOrMobile) {
                        window.open(`/quotes/${data.id}`, "_self")
                    } else {
                        openModal({
                            element: DealModal,
                            id: "DealModal",
                            props: {
                                id: data.id,
                                deal_id: data.id
                            }
                        })
                    }
                },
                ...dealState,
                is_purchase: true,
                is_one_pay: true,
                id: null
            }
        })
    }

    const cloneDealAndOpenModal = () => {
        return cloneDeal(dealState).then((data) => {
            openModal({
                element: DealModal,
                id: "DealModal",
                props: {id: data.data.id},
            })
        })
    }

    const cloneIcon = () => {
        let icon;
        if (isCreatingDeal) {
            icon = <CircularProgress variant="soft" size={'sm'}/>
        } else {
            if (isPurchase) {
                icon = <AddOutlinedIcon className={'isPurchase'}/>
            } else {
                icon = <AccountBalanceIcon/>
            }
        }
        return icon
    }

    const sendEmailQuote = () => {
        openModal({
            element: EmailModal,
            id: "EmailModal",
            props: {
                header: `Check out this Quote`,
                getContent: () => getQuotesDataAndPDFs([dealState.id], "", profileState.account_name, dealState),
                to: "",
                from: profileState.user_email,
                subject: `Lease Quotes from ${profileState.account_name}`,
            }
        })
    }


    const copyQuoteToClipBoardHTML = (isDealer) => {
        if (isCopied) {
            return (
                <div>Copied!</div>
            )
        }

        return (
            <div dangerouslySetInnerHTML={{ __html: copyQuoteHTMLTooltip(dealState, companyName, isDealer) }} />
        )
    }
    const copyQuoteToClipBoard = async (isDealer) => {
        try {
            await navigator.clipboard.write([
                new ClipboardItem({
                    'text/html': new Blob([copyQuoteHTMLTooltip(dealState, companyName, isDealer)], { type: 'text/html' }),
                    'text/plain': new Blob([buildMiniQuoteSummaryString(dealState, isDealer)], { type: 'text/plain' })
                })
            ]);
            setIsCopied(true)
            setTimeout(() =>  {
                setIsCopied(false)
            }, 2000)
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    if (!dealState) return null;

    const updatedAtDate = new Date(dealState.updated_at)
    const expirationDate = dealState.formatted_quote.expiration_date
    const isExpired = new Date(expirationDate).setUTCHours(0,0,0,0) <= new Date().setUTCHours(0,0,0,0)
    const isViewModeOnly = dealState._is_view_mode_only
    const isLocked = dealState.is_locked

    const isCashPurchase = dealState.is_purchase && dealState.is_one_pay

    const headerTitle = {
        true: 'LEASE',
        [dealState.is_purchase]: 'FINANCE',
        [isCashPurchase]: 'CASH'
    }.true

    const getPDFDoc = (isCustomerPDF) => {
        if (dealState.is_purchase && isCustomerPDF) {
            return (<PurchaseCustomerDisclosurePDF
                dealState={dealState}
                customerName={''}
                customerAddress={''}
                companyName={profileState?.account_name}
            />)
        } else if (dealState.is_purchase && !isCustomerPDF) {
            return (
                <PurchaseDealerDisclosurePDF
                    dealState={dealState}
                    companyName={profileState?.account_name}
                />
            )
        } else if (!dealState.is_purchase && isCustomerPDF) {
            return (
                <CustomerDisclosurePDF
                    dealState={dealState}
                    customerName={''}
                    customerAddress={''}
                    companyName={profileState?.account_name}
                />
            )
        } else if (!dealState.is_purchase && !isCustomerPDF) {
            return (
                <DealerDisclosurePDF
                    dealState={dealState}
                    companyName={profileState?.account_name}
                />
            )
        }
    }

    const openPDFModal = (isCustomerPDF) => {
        if (dealState.formatted_quote.source === 'PARTNER_API') {
            openModal({
                id: "DeskingModal",
                element: DeskingModal,
                props: {
                    id: dealState.id,
                    deal_id: dealState.id,
                    ...dealState,
                    onSave: (updateData) => setDealStateWithUpdate(updateData, false),
                }
            })
            return
        }
        openModal({
            element: PDFModal,
            id: "PDFModal",
            props: {
                isCustomerPDF: isCustomerPDF,
                dealState: dealState
            }
        })
    }

    return (
        <Box>
            {
                isViewModeOnly &&
                <Typography
                    variant="h5"
                    component="div"
                    className={'header-title'}
                >
                    VIEW MODE ONLY
                </Typography>

            }
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ color: dealColorLight()}}
                className={'DealPage-header'}
            >
                <div>
                    <Typography
                        variant="h5"
                        component="div"
                        className={'header-title'}
                    >
                        {headerTitle} {isTabletOrMobile ? '' : 'QUOTE'}
                        {
                            isModal &&
                            <Link to={`/quotes/${dealState.id}`} target="_blank" rel="noopener noreferrer" >
                                <OpenInNewOutlinedIcon />
                            </Link>
                        }
                        {
                            !isTabletOrMobile &&
                            <Typography
                                variant="subtitle1"
                                component="div"
                                className={'header-subtitle press-enter'}
                            >
                                Updated {" "}
                                {
                                    `${updatedAtDate.getMonth() + 1}/${updatedAtDate.getDate()} ${updatedAtDate.toLocaleTimeString(undefined, {timeStyle:'short'})}`
                                }
                            </Typography>
                        }
                        {
                            isExpired &&
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{
                                    fontSize: '12px',
                                    color: '#A23325',
                                    marginLeft: '10px'
                                }}
                            >
                                <WarningAmberRoundedIcon/>
                                This program is expired.
                            </Typography>
                        }
                    </Typography>
                </div>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    {
                        false && isFeatureFlagEnabled('crm') && !isTabletOrMobile &&
                        <div
                            className={'lock-icon'}
                        >
                            {
                                isLocked ?
                                    <Tooltip
                                        title={
                                            <Typography color="inherit">
                                                This deal belongs to a client(s) and is locked. It cannot be updated unless you unlock it by clicking the lock icon.
                                            </Typography>
                                        }
                                    >
                                        <LockIcon
                                            onClick={() => setDealStateWithoutUpdate({...dealState, is_locked: false})}
                                        />
                                    </Tooltip>
                                    :
                                    <LockOpenIcon
                                        onClick={() => setDealStateWithoutUpdate({...dealState, is_locked: true})}
                                    />
                            }
                        </div>
                    }
                    <Tooltip
                        title={copyQuoteToClipBoardHTML(true)}
                        arrow placement={'bottom'}
                        slotProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#FFFFFF',
                                    color: 'rgba(0, 0, 0, 0.87)',
                                    padding: isCopied ? '5px': '0px',
                                    fontSize: 12,
                                    border: isCopied ? '1px solid #dadde9': '',
                                }
                            },
                            arrow: {
                                sx: {
                                    color: '#FFFFFF', // Arrow fill color
                                    '&::before': {
                                        border: isCopied ? '1px solid #dadde9': '', // Arrow border
                                    }
                                }
                            }
                        }}
                    >
                        <FileCopyIcon
                            style={{ cursor: 'pointer', marginRight: '10px'}}
                            onClick={() => copyQuoteToClipBoard(true)}
                        />
                    </Tooltip>
                    <Tooltip
                        title={copyQuoteToClipBoardHTML(false)}
                        arrow placement={'bottom'}
                        slotProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#FFFFFF',
                                    color: 'rgba(0, 0, 0, 0.87)',
                                    padding: isCopied ? '5px': '0px',
                                    fontSize: 12,
                                    border: isCopied ? '1px solid #dadde9': '',
                                }
                            },
                            arrow: {
                                sx: {
                                    color: '#FFFFFF', // Arrow fill color
                                    '&::before': {
                                        border: isCopied ? '1px solid #dadde9': '', // Arrow border
                                    }
                                }
                            }
                        }}
                    >
                        <ContentCopyIcon
                            style={{ cursor: 'pointer', marginRight: '10px'}}
                            onClick={() => copyQuoteToClipBoard(false)}
                        />
                    </Tooltip>
                    {
                        isFeatureFlagEnabled('crm') && !isTabletOrMobile &&
                        <div
                            className={'header-button crm'}
                            style={{
                                color: dealColorLight(),
                                border: `2px solid ${dealColorLight()}`
                            }}
                            onClick={() => {
                                openModal({
                                    element: DealCRMModal,
                                    id: "DealCRMModal",
                                    props: {
                                        initialSelectedLeads: dealState.leads,
                                        initialSelectedClients: dealState.clients,
                                        onLeadsSave: (leadIds) => {
                                            setDealStateWithoutQuoteUpdate({leads: leadIds})
                                        },
                                        onClientsSave: (clientIds) => {
                                            setDealStateWithoutQuoteUpdate({clients: clientIds})
                                        }
                                    }
                                })
                            }}
                        >
                            <GroupAddIcon/>
                        </div>
                    }

                    <div
                        onClick={handleClick}
                        className={'header-button tools'}
                        style={{ background: dealColorLight() }}
                    >
                        Tools
                        <ArrowDropDownIcon/>
                    </div>
                    <Popover
                        onClick={(e) => e.stopPropagation()}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            horizontal: 'right',
                            vertical: 'top'
                        }}
                        className={'deal-header-dropdown-menu-container'}
                    >
                        <Box className={'deal-header-dropdown-menu'}>
                            {
                                isTabletOrMobile &&
                                <React.Fragment>
                                    <PDFDownloadLink document={getPDFDoc(true)}>
                                        {({url}) => (
                                            <a
                                                href={url}
                                                target="_blank"
                                                className={classnames('header-button', {
                                                    isPurchase: isPurchase
                                                })}
                                            >
                                                <span
                                                    style={{marginRight: '20px'}}
                                                >
                                                    <PictureAsPdfIcon
                                                        className={classnames('', {
                                                            isPurchase: isPurchase
                                                        })}
                                                    />
                                                 </span>
                                                <span>Customer Worksheet</span>
                                            </a>
                                        )}
                                    </PDFDownloadLink>
                                    <PDFDownloadLink document={getPDFDoc(false)}>
                                        {({url}) => (
                                            <a
                                                href={url}
                                                target="_blank"
                                                className={classnames('header-button', {
                                                    isPurchase: isPurchase
                                                })}
                                            >
                                                        <span
                                                            style={{marginRight: '20px'}}
                                                        >
                                                            <PictureAsPdfIcon
                                                                className={classnames('', {
                                                                    isPurchase: isPurchase
                                                                })}
                                                            />
                                                         </span>
                                                <span>Dealer Worksheet</span>
                                            </a>
                                        )}
                                    </PDFDownloadLink>
                                </React.Fragment>
                            }
                            {
                                !isTabletOrMobile &&
                                <React.Fragment>
                                    <a
                                        onClick={() => openPDFModal(true)}
                                        className={classnames('header-button', {
                                            isPurchase: isPurchase
                                        })}
                                    >

                                    <span
                                        style={{marginRight: '20px'}}
                                    >
                                        <PictureAsPdfIcon
                                            className={classnames('', {
                                                isPurchase: isPurchase
                                            })}
                                        />
                                     </span>
                                        <span>Customer Worksheet</span>
                                    </a>
                                    <a
                                        onClick={() => openPDFModal(false)}
                                        className={classnames('header-button', {
                                            isPurchase: isPurchase
                                        })}
                                    >
                                            <span
                                                style={{marginRight: '20px'}}
                                            >
                                                <PictureAsPdfIcon
                                                    className={classnames('', {
                                                        isPurchase: isPurchase
                                                    })}
                                                />
                                             </span>
                                        <span>Dealer Worksheet</span>
                                    </a>
                                </React.Fragment>
                            }

                            <div
                                onClick={() => deskClonedDeal(!dealState.is_purchase)}
                                className={classnames('header-button', {
                                    isPurchase: isPurchase
                                })}
                            >
                                <span
                                    style={{marginRight: '20px'}}
                                >
                                    {cloneIcon()}
                                </span>
                                <span>
                                    Desk as {isPurchase ? 'Lease ' : 'Purchase '}
                                </span>
                            </div>
                            {
                                isCashPurchase &&
                                <div
                                    onClick={() => deskClonedDeal(true)}
                                    className={classnames('header-button', {
                                        isPurchase: isPurchase
                                    })}
                                >
                                <span
                                    style={{marginRight: '20px'}}
                                >
                                    <AccountBalanceIcon className={classnames('', {
                                        isPurchase: isPurchase || isCashPurchase
                                    })}
                                    />
                                </span>
                                    <span>
                                    Desk as Purchase
                                </span>
                                </div>
                            }
                            {
                                !isCashPurchase &&
                                <div
                                    onClick={deskCashPurchase}
                                    className={classnames('header-button', {
                                        isPurchase: isPurchase
                                    })}
                                >
                                <span
                                    style={{marginRight: '20px'}}
                                >
                                    <AttachMoneyIcon className={classnames('', {
                                        isPurchase: isPurchase
                                    })}
                                    />
                                </span>
                                    <span>
                                    Desk as Cash
                                </span>
                                </div>
                            }

                            <div
                                onClick={cloneDealAndOpenModal}
                                className={classnames('header-button', {
                                    isPurchase: isPurchase
                                })}
                            >
                                <span
                                    style={{marginRight: '20px'}}
                                >
                                    <ContentCopyIcon className={classnames('', {
                                        isPurchase: isPurchase
                                    })}/>
                                </span>
                                <span>
                                    Clone Quote
                                </span>
                            </div>

                            <div
                                onClick={sendEmailQuote}
                                className={classnames('header-button', {
                                    isPurchase: isPurchase
                                })}
                            >
                                <span
                                    style={{marginRight: '20px'}}
                                >
                                    <SendIcon className={classnames('', {
                                        isPurchase: isPurchase
                                    })}/>
                                </span>
                                <span>
                                    Send Email
                                </span>
                            </div>
                            <div
                                onClick={() => {
                                    return deleteDeal(dealState.id).then(() => {
                                        window.location.replace("/quotes")
                                    })
                                }}
                                className={classnames('header-button', {
                                    isPurchase: isPurchase
                                })}
                            >
                                <span
                                    style={{marginRight: '20px'}}
                                >
                                    <DeleteSharpIcon style={{color: "#A23325"}}/>
                                </span>
                                <span>
                                    Delete Quote
                                </span>
                            </div>
                        </Box>
                    </Popover>
                </Stack>
            </Stack>
        </Box>
    );
};

export default DealHeader;